import apiService from '../../services/ApiService';
import platformDetection from './PlatformDetection';

const resumeSessionUtils = {
    token: undefined,

    init() {
        if (!platformDetection.isIOSApp()) // resume session is available only for IOS app
            return;

        apiService.getSessionToken()
            .then(response => {
                this.token = response.token;
            });
    },
    resumeSession() {
        if (!this.token)
            return;

        apiService.doLoginWithToken(this.token)
            .then(response => {
                return true;
            });
    },
};

export default resumeSessionUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/ResumeSessionUtils.js
 **/